import { Component, computed, effect, input } from '@angular/core';
import { AlerteComponent } from '@shared/components/alerte/alerte.component';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmLabelImports } from '@spartan-ng/helm/label';

import { Aptitude } from '../../../référentiel-métier/référentiel-métier-processus/processus-aptitude/models/aptitude.model';
import { Production } from '../../../référentiel-métier/référentiel-métier-processus/processus-aptitude/models/production.model';
import { ActivitéFormService } from '../activité-form.service';

@Component({
  selector: 'app-productions',
  imports: [HlmFieldImports, HlmCheckboxImports, TrierParPipe, AlerteComponent, HlmLabelImports],
  templateUrl: './productions.component.html',
})
export class ProductionsComponent {
  readonly formService = input.required<ActivitéFormService>();

  readonly productions = computed(() =>
    (this.formService().aptitudePrincipaleAptitude.value
      ? [this.formService().aptitudePrincipaleAptitude.value, ...this.formService().aptitudesSecondaires.value]
      : []
    ).flatMap((x) => x.productions ?? []),
  );

  constructor() {
    effect(() => {
      const formService = this.formService();

      const aptitudes: Aptitude[] = this.formService().aptitudePrincipaleAptitude.value
        ? [this.formService().aptitudePrincipaleAptitude.value, ...this.formService().aptitudesSecondaires.value]
        : [];
      const productions = (formService.productions.value as Production[]).filter((x) =>
        aptitudes.map((x) => x.id).includes(x.idAptitude),
      );
      formService.productions.setValue(productions, { emitEvent: false });
    });
  }

  onCheckboxChange(checked: boolean, item: Production) {
    const formControl = this.formControl;
    const values = formControl.value;
    if (checked) {
      if (!values.map((v) => v.nom).includes(item.nom)) {
        formControl.setValue([...values, item]);
      }
    } else {
      const idxToDelete = values.findIndex((x) => x.id == item.id);
      if (idxToDelete > -1) {
        values.splice(idxToDelete, 1);
        formControl.setValue([...values]);
      }
    }
  }

  isChecked = (item: string) =>
    this.formControl.value.findIndex((x: { id: string; nom: string }) => x.id == item || x.nom == item) > -1;

  get formControl() {
    return this.formService().productions;
  }
}
